import Kakao from '../kakao';

onload(() => {
  // Kakao
  if (!Kakao.isInitialized()) Kakao.init(window._kakaoKey);
}, {});